import { useEffect, useCallback, useState } from "react";
import { toast } from "react-toastify";
import AuthService from "services/auth.service";

/**
 * Fetches notifications on mount (once per session via localStorage gate),
 * shows them as toasts, and marks them read on close.
 */
export default function useNotificationData() {
  const currentUser = AuthService.getCurrentUser();
  const id = currentUser?.id;
  const [notifications, setNotifications] = useState([]);

  const markAsRead = useCallback((notificationId) => {
    AuthService.markNotificationAsRead(notificationId).catch((error) =>
      console.error("Error marking notification as read:", error)
    );
  }, []);

  const showNotifications = useCallback(
    (notifs) => {
      let index = 0;

      const showNext = () => {
        if (index < notifs.length) {
          const notification = notifs[index];
          if (!notification.read) {
            toast.warn(
              <p>
                <b>{notification.title}</b> <br /> {notification.message}
              </p>,
              {
                position: "bottom-right",
                autoClose: 7000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                onClose: () => markAsRead(notification.id),
              }
            );
          }
          index++;
          setTimeout(showNext, 4000);
        }
      };

      showNext();
    },
    [markAsRead]
  );

  useEffect(() => {
    const hasSeen = localStorage.getItem("hasSeenNotification");
    if (hasSeen || !id) return;

    AuthService.fetchNotification(id)
      .then((response) => {
        setNotifications(response.data);
        showNotifications(response.data);
        localStorage.setItem("hasSeenNotification", "true");
      })
      .catch((error) =>
        console.error("Error fetching notification:", error)
      );
  }, [id, showNotifications]);

  return { notifications, markAsRead };
}